import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	loadingUimFailed: {
		id: 'ui-modifications-view-gic.use-ui-modifications-errors.loading-uim-failed',
		defaultMessage: "We couldn't load the UI modifications for this form.",
		description:
			'A warning that gets displayed when unknown error occurred during UI modifications processing in Jira',
	},
	loadingUimDataFailed: {
		id: 'ui-modifications-view-gic.use-ui-modifications-errors.loading-uim-data-failed',
		defaultMessage: "We couldn't load the UI modifications configuration for this form.",
		description:
			'A warning that gets displayed when known error occurred during UI modifications data loading in Jira',
	},
	applyingUimFailed: {
		id: 'ui-modifications-view-gic.use-ui-modifications-errors.applying-uim-failed',
		defaultMessage: 'We encountered an error while applying UI modifications to this form.',
		description:
			'A warning that gets displayed when known error occurred during UI modifications processing in Jira',
	},
	appDoesNotHaveRequiredScopes: {
		id: 'ui-modifications-view-gic.use-ui-modifications-errors.app-does-not-have-required-scopes',
		defaultMessage:
			'We couldn’t load some of the UI modifications apps for this page, because they don’t have required scopes.',
		description:
			'A warning that gets displayed when an app with UI modifications module does not have required scopes in the manifest',
	},
	multiAppConflict: {
		id: 'ui-modifications-view-gic.use-ui-modifications-errors.multi-app-conflict',
		defaultMessage:
			'Multiple UI modifications apps tried to call the same API method. All customizations have been dismissed.',
		description:
			'An error that gets displayed when multiple UI modifications apps tried to modify the same property of the same field or two apps try to modify screen tabs.',
	},
	bufferTimeout: {
		id: 'ui-modifications-view-gic.use-ui-modifications-errors.buffer-timeout',
		defaultMessage:
			'Some of the UI modifications apps did not apply changes before the timeout and have been dismissed.',
		description:
			'An error that gets displayed when one or more UI modifications apps have been processing too long.',
	},
});
